<template>
  <div>

    <button class="gx-shop__btn-add" @click="openAdd">
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M6 1v10M1 6h10" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" /></svg>
      新增{{ isWechat ? '微店' : '抖店' }}
    </button>
    <!-- 筛选卡 -->
    <div class="gx-shop__filter">
      <!-- Row 1: 上货应用状态 -->
      <div class="gx-shop__app-filter-row">
        <span class="gx-shop__app-filter-label">上货应用状态</span>
        <div class="gx-shop__app-filter-btns">
          <button v-for="f in appStatusFilter" :key="f.label" class="gx-shop__app-filter-btn" :class="{ 'gx-shop__app-filter-btn--on': goodsStatus === f.val }" @click="setGoodsStatus(f.val)">{{ f.label }}</button>
        </div>
      </div>

      <!-- Row 2: 订单应用状态（仅抖店） -->
      <div v-if="!isWechat" class="gx-shop__app-filter-row">
        <span class="gx-shop__app-filter-label">订单应用状态</span>
        <div class="gx-shop__app-filter-btns">
          <button v-for="f in appStatusFilter" :key="f.label" class="gx-shop__app-filter-btn" :class="{ 'gx-shop__app-filter-btn--on': orderStatus === f.val }" @click="setOrderStatus(f.val)">{{ f.label }}</button>
        </div>
      </div>

      <!-- Row 3: 批量操作 -->
      <div class="gx-shop__app-filter-row gx-shop__bulk" v-if="is_host">
        <button class="gx-shop__bulk-btn" @click="selectAll">全选</button>
        <button class="gx-shop__bulk-btn" @click="unSelectAll">反选</button>
        <button class="gx-shop__bulk-btn" :disabled="!selectedShopIds.length" @click="openBatchGroup">设置分组</button>
        <button class="gx-shop__bulk-btn" @click="openGroupMgmt">分组管理</button>
      </div>
      <!-- Row 4 -->
      <div class="custom-el-wrapper custom-form-wrap">
        <el-form inline size="mini">
          <el-form-item label="主营类目：">
            <el-select size="mini" v-model="searchData.main_category" clearable multiple collapse-tags placeholder="全部" class="w220" @change="doSearch">
              <el-option v-for="(value, key) in mainCategoryList" :key="key" :label="value" :value="key" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分组：">
            <el-select size="mini" v-model="searchData.shop_groupids" class="w220" multiple clearable collapse-tags placeholder="全部分组" @change="doSearch">
              <el-option v-for="group in groupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
              <el-option v-if="is_host" label="未分组" value="-1">未分组</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="店铺名：">
            <el-input size="mini"  class="w220" v-model="searchData.shop_name" placeholder="请输入店铺名" clearable value="" @change="doSearch"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <!-- 店铺卡片网格 -->
    <div v-if="filteredList.length" class="gx-shop__cards">
      <div v-for="s in filteredList" :key="s.shop_id" class="gx-shop__card" :class="isWechat ? 'gx-shop__card--wx' : 'gx-shop__card--dy'">
        <!-- 复选框 左上 -->
        <span
            class="gx-shop__check"
            :class="{ 'gx-shop__check--on': selectedShopIds.includes(s.shop_id) }"
            @click="toggleSelect(s.shop_id)"
        >
          <svg v-if="selectedShopIds.includes(s.shop_id)" width="9" height="9" viewBox="0 0 9 9" fill="none"><path d="M1.5 4.5l2 2 4-4" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
        </span>

        <div style="display: flex;justify-content: space-between">
          <!-- 头部：头像 + 名称 + 平台标签 -->
          <div class="gx-shop__card-head">
            <span class="gx-shop__card-icon">{{ s.shop_name ? s.shop_name[0] : '店' }}</span>
            <div class="gx-shop__card-info">
              <div class="gx-shop__card-name">{{ s.shop_name }}</div>
              <span class="gx-shop__card-plat" :class="isWechat ? 'gx-shop__card-plat--wx' : 'gx-shop__card-plat--dy'">{{ isWechat ? '微店' : '抖店' }}</span>
            </div>
          </div>
          <!-- 关店 右上 -->
          <div class="gx-shop__card-close">
            <button class="gx-shop__card-btn" @click="openMoveConfig(s)" >搬家配置</button>
            <button class="gx-shop__card-btn" @click="openClose(s)">关店</button>
          </div>
        </div>

        <div class="gx-shop__card-divider"></div>

        <!-- 主营类目 + 分组 -->
        <div class="gx-shop__card-meta">
          <div class="gx-shop__card-meta-row">
            <span class="gx-shop__card-meta-label">主营类目：</span>
            <span class="gx-shop__card-meta-val">{{ s.shop_category_main_name && s.shop_category_main_name.length ? s.shop_category_main_name[0] : '--' }}</span>
          </div>
          <div class="gx-shop__card-meta-row">
            <span class="gx-shop__card-meta-label">分组：</span>
            <span class="gx-shop__card-meta-val">{{ s.group_name || '未分组' }}</span>
          </div>
        </div>

        <!-- 商品应用 block -->
        <div class="gx-shop__app-block">
          <div class="gx-shop__app-block-row">
            <div class="gx-shop__app-block-title">
              <span class="gx-shop__app-block-name">商品应用：</span>
              <span class="gx-shop__app-block-sub" :class="isGoodsSubscribed(s) ? 'gx-shop__app-block-sub--ok' : ''">{{ goodsAppText(s) }}</span>
            </div>
            <a v-if="s.goods_app_renew_url" :href="s.goods_app_renew_url" target="_blank" class="gx-shop__app-block-btn">{{ isGoodsSubscribed(s) ? '续订' : '订购' }}</a>
          </div>
          <div class="gx-shop__app-block-row">
            <span class="gx-shop__app-block-label">授权状态：</span>
            <span class="gx-shop__app-block-status" :class="isGoodsAuthOk(s) ? 'gx-shop__app-block-status--ok' : 'gx-shop__app-block-status--err'">
              <span class="gx-shop__app-block-dot"></span>{{ isGoodsAuthOk(s) ? '授权正常' : '授权异常' }}
            </span>
          </div>
          <div class="gx-shop__app-block-row">
            <span class="gx-shop__app-block-label">到期时间：</span>
            <span class="gx-shop__app-block-expire">{{ formatExpireTime(s.app_expire_time) || s.app_expire_time_b_text || '未订购' }}</span>
          </div>
          <a v-if="s.goods_app_url" :href="s.goods_app_url" target="_blank" class="gx-shop__app-block-reauth">重新授权</a>
        </div>

        <!-- 订单应用 block（仅抖店） -->
        <div v-if="!isWechat" class="gx-shop__app-block">
          <div class="gx-shop__app-block-row">
            <div class="gx-shop__app-block-title">
              <span class="gx-shop__app-block-name">订单应用：</span>
              <span class="gx-shop__app-block-sub" :class="isOrderSubscribed(s) ? 'gx-shop__app-block-sub--ok' : ''">{{ orderAppText(s) }}</span>
            </div>
            <a v-if="s.goods_app_renew_url" :href="s.goods_app_renew_url" target="_blank" class="gx-shop__app-block-btn">{{ isOrderSubscribed(s) ? '续订' : '订购' }}</a>
          </div>
          <div class="gx-shop__app-block-row">
            <span class="gx-shop__app-block-label">授权状态：</span>
            <span class="gx-shop__app-block-status" :class="s.app_order_status == 1 ? 'gx-shop__app-block-status--ok' : 'gx-shop__app-block-status--err'">
              <span class="gx-shop__app-block-dot"></span>{{ s.app_order_status == 1 ? '授权正常' : '授权异常' }}
            </span>
          </div>
          <div class="gx-shop__app-block-row">
            <span class="gx-shop__app-block-label">到期时间：</span>
            <span class="gx-shop__app-block-expire">{{ formatExpireTime(s.app_expire_time_order) || '未订购' }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="gx-shop__empty">暂无符合条件的店铺</div>

    <div class="gx-shop__count">共 {{ filteredList.length }} 条</div>

    <!-- 弹窗：新增抖店（选择应用） -->
    <div v-if="dialog === 'addDouyin'" class="gx-shop__modal" @click.self="dialog = null">
      <div class="gx-shop__modal-box gx-shop__modal-box--apps">
        <div class="gx-shop__modal-head">
          <span class="gx-shop__modal-title">选择应用</span>
          <button class="gx-shop__modal-close" @click="dialog = null">✕</button>
        </div>
        <div class="gx-shop__modal-body">
          <div class="gx-shop__apps">
            <button
                v-for="app in apps"
                :key="app.id"
                class="gx-shop__app-card"
                :class="{ 'gx-shop__app-card--on': selectedApp === app.id }"
                @click="selectedApp = app.id"
            >
              <!--                  <span class="gx-shop__app-card-icon" v-html="app.icon"></span>-->
              <span class="gx-shop__app-card-icon">{{app.icon}}</span>
              <span class="gx-shop__app-card-name">{{ app.name }}</span>
              <span class="gx-shop__app-card-sub">{{ app.sub }}</span>
              <span class="gx-shop__app-card-desc">{{ app.desc }}</span>
            </button>
          </div>
          <div class="gx-shop__modal-foot">
            <button class="gx-shop__btn" @click="dialog = null">取消</button>
            <button class="gx-shop__btn gx-shop__btn--add" :disabled="!selectedApp" @click="nextAddDouyin">下一步</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗：新增微店 -->
    <div v-if="dialog === 'addWeixin'" class="gx-shop__modal" @click.self="dialog = null">
      <div class="gx-shop__modal-box">
        <div class="gx-shop__modal-head" style="background: #ffffff">
          <span class="gx-shop__modal-title">新增微店店铺</span>
          <button class="gx-shop__modal-close" @click="dialog = null">✕</button>
        </div>
        <div class="gx-shop__modal-body" style="padding:24px 20px">
          <div class="gx-shop__modal-steps-title">添加说明</div>
          <div class="gx-shop__modal-steps">
            <div v-for="(step, i) in wechatSteps" :key="i" class="gx-shop__modal-step">
              <span class="gx-shop__modal-step-num">{{ i + 1 }}</span>
              <span>{{ step }}</span>
            </div>
          </div>
          <div>
<!--          <a class="gx-shop__modal-jump" :href="wechatBuyUrl || 'https://fuwu.jinritemai.com'" target="_blank">点击跳转购买服务</a>-->
            <a class="gx-shop__modal-jump" @click="goWechatBuy(wechatBuyUrl)">点击跳转购买「星好货铺货」服务</a>
            <div class="gx-shop__modal-label--strong">授权码</div>
            <div class="gx-shop__modal-code-row">
              <input v-model="authCode" class="gx-shop__modal-input" placeholder="粘贴授权码..." />
              <button class="gx-shop__btn gx-shop__btn--add red" :disabled="!authCode || wechatChecking" @click="previewWechatShop">
                {{ wechatChecking ? '获取中...' : '下一步' }}
              </button>
            </div>
          </div>
          <div style="margin-top: 20px;">
            <a class="gx-shop__modal-jump" @click="goWechatBuy(wechatBuyUrl2)">点击跳转购买「星好货打单」服务</a>
            <div class="gx-shop__modal-label--strong">授权码</div>
            <div class="gx-shop__modal-code-row">
              <input v-model="authCode2" class="gx-shop__modal-input" placeholder="粘贴授权码..." />
              <button class="gx-shop__btn gx-shop__btn--add red" :disabled="!authCode2 || wechatChecking2" @click="submitWechatShop2">
                {{ wechatChecking2 ? '绑定中...' : '绑定' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗：确认新增微店 -->
    <div v-if="dialog === 'confirmWeixin'" class="gx-shop__modal" @click.self="dialog = null">
      <div class="gx-shop__modal-box gx-shop__modal-box--sm">
        <div class="gx-shop__modal-head">
          <span class="gx-shop__modal-title">确认添加微信店铺</span>
          <button class="gx-shop__modal-close" @click="dialog = null">✕</button>
        </div>
        <div class="gx-shop__modal-body">
          <div class="gx-shop__modal-warn">
            <p>是否要添加店铺「<span class="gx-shop__modal-warn-name">{{ wechatShopInfo.shop_name }}</span>」到当前账号？</p>
          </div>
          <div class="gx-shop__modal-foot">
            <button class="gx-shop__btn" @click="dialog = null">取消</button>
            <button class="gx-shop__btn gx-shop__btn--add" :disabled="wechatAdding" @click="confirmAddWechat">
              {{ wechatAdding ? '添加中...' : '确认添加' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗：关店 -->
    <div v-if="closeShop" class="gx-shop__modal" @click.self="closeShop = null">
      <div class="gx-shop__modal-box gx-shop__modal-box--sm">
        <div class="gx-shop__modal-head">
          <span class="gx-shop__modal-title">关闭店铺</span>
          <!--              <button class="gx-shop__modal-close" @click="closeShop = null">✕</button>-->
        </div>
        <div class="gx-shop__modal-body">
          <div class="gx-shop__modal-warn">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" style="flex-shrink: 0; margin-top: 1px;"><path d="M9 1.5l8 14H1L9 1.5z" stroke="#C8443C" stroke-width="1.3" stroke-linejoin="round"></path><path d="M9 7v4M9 13v.5" stroke="#C8443C" stroke-width="1.3" stroke-linecap="round"></path></svg>
            <p>确认关闭店铺「<span class="gx-shop__modal-warn-name">{{ closeShop.shop_name }}</span>」吗？<br />
              <span style="color: #999999">关闭后该店铺将停止同步，无法恢复，请谨慎操作。</span></p>
          </div>
          <div class="gx-shop__modal-label--strong">登录密码</div>
          <input v-model="closePwd" type="password" class="gx-shop__modal-input" placeholder="请输入登录密码" />
          <div class="gx-shop__modal-foot">
            <button class="gx-shop__btn" @click="closeShop = null">取消</button>
            <button class="gx-shop__btn gx-shop__btn--danger" :disabled="!closePwd || closing" @click="confirmClose">
              {{ closing ? '处理中...' : '确定关店' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗：设置分组 -->
    <div v-if="batchGroupVisible" class="gx-shop__modal" @click.self="batchGroupVisible = false">
      <div class="gx-shop__modal-box gx-shop__modal-box--sm">
        <div class="gx-shop__modal-head">
          <span class="gx-shop__modal-title">设置店铺分组</span>
          <button class="gx-shop__modal-close" @click="batchGroupVisible = false">✕</button>
        </div>
        <div class="gx-shop__modal-body custom-el-wrapper">
          <div class="gx-shop__batch-count">
            <div class="gx-shop__batch-count-dot"></div>
            <span>已选店铺：{{ selectedShopIds.length }} 个</span>
          </div>
          <div class="gx-shop__modal-label">目标分组</div>
          <el-select v-model="batchGroupId" size="mini" placeholder="请选择分组" clearable style="width: 300px">
            <el-option label="移出分组" :value="0"></el-option>
            <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <div class="gx-shop__modal-foot">
            <button class="gx-shop__btn" @click="batchGroupVisible = false">取消</button>
            <button class="gx-shop__btn gx-shop__btn--add" :disabled="batchGroupLoading" @click="confirmBatchGroup">
              {{ batchGroupLoading ? '设置中...' : '确定' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗：分组管理 -->
    <div v-if="groupMgmtVisible" class="gx-shop__modal" @click.self="groupMgmtVisible = false">
      <div class="gx-shop__modal-box gx-shop__modal-box--lg">
        <div class="gx-shop__modal-head">
          <span class="gx-shop__modal-title">店铺分组管理</span>
          <button class="gx-shop__modal-close" @click="groupMgmtVisible = false">✕</button>
        </div>
        <div class="gx-shop__modal-body">
          <div class="gx-shop__gm-toolbar">
            <button class="gx-shop__btn" @click="openGroupForm(null)">
              <svg width="11" height="11" viewBox="0 0 11 11" fill="none"><path d="M5.5 1v9M1 5.5h9" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" /></svg>
              新增分组
            </button>
          </div>
          <div class="gx-shop__gm-table">
            <table>
              <thead>
              <tr>
                <th v-for="h in ['分组名称', '店铺数', '排序', '操作']" :key="h">{{ h }}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(g,i) in groupList" :key="g.id">
                <td class="gx-shop__gm-name">{{ g.name }}</td>
                <td class="gx-shop__gm-count">{{ g.count || 0 }}</td>
                <td>
                  <div class="gx-shop__gm-sort">
                    <button @click="moveGroup(g, i,'asc')">↑</button>
                    <button @click="moveGroup(g, i,'desc')">↓</button>
                  </div>
                </td>
                <td>
                  <div class="gx-shop__gm-ops">
                    <button class="gx-shop__gm-op gx-shop__gm-op--edit" @click="openGroupForm(g)">编辑</button>
                    <button class="gx-shop__gm-op gx-shop__gm-op--del" @click="delGroup(g)">删除</button>
                  </div>
                </td>
              </tr>
              <tr v-if="!groupList.length">
                <td :colspan="4" class="gx-shop__empty">暂无分组</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="gx-shop__modal-foot no-top-bor">
            <button class="gx-shop__btn gx-shop__btn--add" @click="groupMgmtVisible = false">完成</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗：新增/编辑分组 -->
    <div v-if="groupFormVisible" class="gx-shop__modal" @click.self="groupFormVisible = false">
      <div class="gx-shop__modal-box gx-shop__modal-box--sm">
        <div class="gx-shop__modal-head">
          <span class="gx-shop__modal-title">{{ groupForm.id ? '编辑分组' : '新增分组' }}</span>
          <button class="gx-shop__modal-close" @click="groupFormVisible = false">✕</button>
        </div>
        <div class="gx-shop__modal-body">
          <div class="gx-shop__modal-label">分组名称</div>
          <el-input v-model="groupForm.name" size="small" maxlength="50" show-word-limit placeholder="请输入分组名称" ></el-input>
          <div class="gx-shop__modal-label" style="margin-top: 16px">排序值</div>
          <div class="gx-shop__gm-sort-input">
            <button @click="groupForm.sort = Math.max(0, groupForm.sort - 1)">−</button>
            <input v-model.number="groupForm.sort" type="number" min="0" />
            <button @click="groupForm.sort += 1">+</button>
          </div>
          <div class="gx-shop__modal-foot">
            <button class="gx-shop__btn" @click="groupFormVisible = false">取消</button>
            <button class="gx-shop__btn gx-shop__btn--add" :disabled="groupFormLoading" @click="submitGroupForm">
              {{ groupFormLoading ? '保存中...' : '确定' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗：温馨提示 -->
    <el-dialog
        title="温馨提示"
        :visible.sync="accountReminders"
        width="480px"
        append-to-body
        modal-append-to-body
        :close-on-click-modal="false"
        class="custom-el-wrapper"
    >
      <div class="account_reminder_dialog">
        <p class="account_reminder_tip"><i class="el-icon-warning"></i> 以下账号/应用需要您及时处理，避免影响正常采购与订单同步。</p>
        <div class="account_reminder_block" v-for="(section, sIndex) in accountReminderSections" :key="'section_' + sIndex">
          <p class="account_reminder_label">{{ section.label }}</p>
          <div class="account_reminder_item" v-for="(item, iIndex) in section.items" :key="'item_' + sIndex + '_' + iIndex">
            <span class="account_reminder_type">{{ item.text }}：</span>
            <span class="account_reminder_names">{{ item.names.join('、') }}</span>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="accountReminders = false">我知道了</el-button>
        <el-button type="primary" v-if="hasPurchaseAccountReminder" @click="goPurchaseManage">前往采购管理</el-button>
      </div>
    </el-dialog>

    <!-- 弹窗：搬家配置 -->
    <DdMoveConfig ref="ddMoveConfigRef"></DdMoveConfig>
    <WxMoveConfig ref="wxMoveConfigRef"></WxMoveConfig>
    <!-- 弹窗：Isv -->
    <IsvDialog ref="isvDialogRef"></IsvDialog>
  </div>

</template>

<script>
import { mapActions, mapMutations } from 'vuex'

import newUiPermissionMixin from '../../mixins/newUiPermission'
import DdMoveConfig from "./DdMoveConfig.vue";
import WxMoveConfig from "./WxMoveConfig.vue";
import IsvDialog from "./IsvDialog.vue";
import WechatCategoryManager from './WechatCategoryManager.vue'

const APP_ICONS = {
  goods:'🛍️',
  order:'📦'
}

export default {
  name: 'NewShopWorkbenchPage',
  mixins: [newUiPermissionMixin],
  props:{
    initialShopType:{
      type:Number,
      default:1
    }
  },
  components: {DdMoveConfig,WxMoveConfig,IsvDialog,WechatCategoryManager},
  data() {
    return {
      is_host: false,//是否是主账号
      shopType: 1,
      searchData: {},
      mainCategoryList: {},
      goodsStatus: '',
      orderStatus: '',
      appStatusFilter: [
        { label: '全部', val: '' },
        { label: '正常', val: '1' },
        { label: '失效', val: '2' }
      ],
      selectedShopIds: [],
      list: [],
      groupList: [],
      dialog: null,
      selectedApp: null,
      apps: [
        { id: 'goods', appType: 'product', name: '商品应用', sub: '', icon: APP_ICONS.goods, desc: '商品铺货、SKU管理、标题优化', authorizeUrl: '' },
        { id: 'order', appType: 'order', name: '订单应用', sub: '', icon: APP_ICONS.order, desc: '订单管理、自动发货、售后跟踪', authorizeUrl: '' }
      ],
      authCode: '',
      wechatChecking: false,
      wechatAdding: false,
      wechatShopInfo: { auth_code: '', shop_name: '', appid: '' },
      wechatBuyUrl: '',
      authCode2: '',
      wechatChecking2: false,
      wechatBuyUrl2: 'https://store.weixin.qq.com/shop/servicemarket/detail?serviceId=3617232724823212042',
      wechatSteps: ['点击下方按钮跳转购买服务', '在微信小店服务市场「我的服务」中点击「去使用」', '在使用页面复制授权码，并在下方输入'],
      closeShop: null,
      closePwd: '',
      closing: false,
      batchGroupVisible: false,
      batchGroupId: '',
      batchGroupLoading: false,
      groupMgmtVisible: false,
      groupFormVisible: false,
      groupForm: { id: null, name: '', sort: 0 },
      groupFormLoading: false,
      //温馨提示弹窗相关变量
      accountReminders:false,
      accountReminderSections: [],
      hasPurchaseAccountReminder: false,
      reminderDialogKey: '',
    }
  },
  watch:{
    initialShopType(){
      this.initData()
    }
  },
  computed: {
    isWechat() {
      return this.shopType == 7
    },
    unreadCount() {
      const notifs = this.$store.state.notification.notifications || []
      return notifs.filter((n) => !n.isRead).length
    },
    filteredList() {
      return this.list.filter((s) => {
        if (this.goodsStatus && String(this.goodsStatusValue(s)) !== this.goodsStatus) return false
        if (!this.isWechat && this.orderStatus && String(s.app_order_status) !== this.orderStatus) return false
        return true
      })
    },
    categoryOptions() {
      return ['全部'].concat(Object.keys(this.mainCategoryList).map((k) => this.mainCategoryList[k]))
    },
    categoryText() {
      if (!this.searchData.main_category || !this.mainCategoryList[this.searchData.main_category]) return '全部'
      return this.mainCategoryList[this.searchData.main_category]
    },
    groupOptions() {
      return ['全部分组'].concat(this.groupList.map((g) => g.name))
    },
    groupText() {
      if (!this.searchData.shop_groupids) return '全部分组'
      const g = this.groupList.find((x) => String(x.id) === String(this.searchData.shop_groupids))
      return g ? g.name : '全部分组'
    },
    batchGroupOptions() {
      return ['请选择分组'].concat(this.groupList.map((g) => g.name))
    },
    batchGroupIdText() {
      if (!this.batchGroupId) return '请选择分组'
      const g = this.groupList.find((x) => String(x.id) === String(this.batchGroupId))
      return g ? g.name : '请选择分组'
    }
  },
  created() {
    this.is_host = !(this.$store.state.login.is_host === 'false')
    this.initData()
  },
  mounted() {
    console.log('切换：',this.initialShopType)
  },
  methods: {
    ...mapActions({
      getDdShopList: 'ucenter/getDdShopList',
      getShopBoardGroupList: 'shop_board/getShopBoardGroupList',
      opGetShopMainCategory: 'ucenter/opGetShopMainCategory',
      addWechatShop: 'ucenter/addWechatShop',
      getWechatShopAuthCode: 'ucenter/getWechatShopAuthCode',
      opCloseShop: 'ucenter/opCloseShop',
      opShopBoardBatchSetGroup: 'shop_board/opShopBoardBatchSetGroup',
      opShopBoardGroupCreate: 'shop_board/opShopBoardGroupCreate',
      opShopBoardGroupUpdate: 'shop_board/opShopBoardGroupUpdate',
      opShopBoardGroupDelete: 'shop_board/opShopBoardGroupDelete',
      getAccountReminders:"ucenter/getAccountReminders",
      getGoodsList: "ucenter/getGoodsList",
      getBusinessUserId: "ucenter/getBusinessUserId",
      bindWxShopByAuthCode: "wxshopShop/bindShopAction",
    }),
    ...mapMutations({
      OUT_LOGIN: 'login/OUT_LOGIN'
    }),
      initData() {
        this.shopType = this.initialShopType || 1
        this.searchData={}
        this.selectedShopIds= []
            this.list= []
            this.groupList= []
        this.fetchAndSaveBusinessUserId()
        this.loadGroups()
        this.loadMainCategory()
        this.getList(true)
        this.loadAccountReminders()
        this.getDdProductExistCategoryMisplaced();//获取类目不正确的商品
      },
    fetchAndSaveBusinessUserId() {
      this.getBusinessUserId({
        data: {},
        success: (res) => {
          if (res.code === 200) {
            const businessUserId = res.data && res.data.business_user_id
            if (businessUserId) {
              localStorage.setItem('business_user_id', String(businessUserId))
            }
          } else if (res.code === 201) {
            this.OUT_LOGIN()
          }
        }
      })
    },
    loadGroups() {
      this.getShopBoardGroupList({
        data: {},
        success: (res) => {
          if (res.code === 200) this.groupList = res.data || []
        }
      })
    },
    loadMainCategory() {
      this.opGetShopMainCategory({
        data: { shop_type: this.shopType },
        success: (res) => {
          if (res.code === 200) this.mainCategoryList = res.data || {}
        }
      })
    },
    getList() {
      const param = { page_size: 100, page: 1, shop_type: this.shopType }
      // if (this.goodsStatus) param.expire_status = this.goodsStatus
      if (this.searchData.shop_groupids) param.shop_groupids = this.searchData.shop_groupids
      if (this.searchData.shop_name) param.shop_name = this.searchData.shop_name
      if (this.searchData.main_category) param.main_category = this.searchData.main_category
      this.getDdShopList({
        data: param,
        success: (res) => {
          if (res.code === 200) {
            const d = res.data
            this.list = d.list && d.list.list ? d.list.list : (Array.isArray(d.list) ? d.list : (Array.isArray(d) ? d : []))
            if (this.shopType === 1) {
              const authorizeList = Array.isArray(d.Authorization_url) ? d.Authorization_url : []
              this.apps = this.apps.map((app) => {
                const authorize = authorizeList.find((item) => item.app_type === app.appType)
                return {
                  ...app,
                  sub: authorize ? authorize.app_name : '',
                  authorizeUrl: authorize ? authorize.authorize_url : ''
                }
              })
            }
            if (d.weChat_url) {
              this.wechatBuyUrl = d.weChat_url
            }
            this.selectedShopIds = this.selectedShopIds.filter((id) => this.list.some((s) => s.shop_id === id))
          } else {
            this.$message({ message: res.msg || res.message, type: 'error' })
          }
        }
      })
    },
    formatExpireTime(time) {
      if (!time) return ''
      if (typeof time === 'string' && !/^\d+$/.test(time)) return time
      const date = new Date(Number(time) * 1000)
      if (Number.isNaN(date.getTime())) return ''
      const pad = (number) => String(number).padStart(2, '0')
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    },
    // 商品应用是否已订购（优先使用接口订购标识，兼容旧接口）
    isGoodsSubscribed(s) {
      return typeof s.goods_app_subscribed === 'boolean' ? s.goods_app_subscribed : !!s.goods_app_name
    },
    // 商品应用展示文案：已订购时显示应用名，未订购显示"未订购"
    goodsAppText(s) {
      return s.goods_app_name || '未订购'
    },
    // 订单应用是否已订购（优先使用接口订购标识，兼容旧接口）
    isOrderSubscribed(s) {
      return typeof s.order_app_subscribed === 'boolean' ? s.order_app_subscribed : !!s.order_app_name
    },
    // 订单应用展示文案：已订购时显示应用名，未订购显示"未订购"
    orderAppText(s) {
      return s.order_app_name || '未订购'
    },
    // 商品应用授权状态：微信店用 status（1 正常 / 2 异常，与旧版一致），抖店用 app_product_status
    isGoodsAuthOk(s) {
      if (this.isWechat) return Number(s.status) === 1
      return s.app_product_status == 1
    },
    // 上货应用状态筛选的取值字段，随平台区分
    goodsStatusValue(s) {
      return this.isWechat ? s.status : s.app_product_status
    },
    doSearch() {
      if(this.$store.state.login.user_level == 9 && this.searchData.shop_groupids) {
        this.searchData.shop_groupids = []
        this.$message.error('普通会员无法使用分组');
        return
      }
      this.getList(true)
    },
    onCategoryChange(name) {
      if (name === '全部') {
        this.searchData.main_category = ''
      } else {
        const id = Object.keys(this.mainCategoryList).find((k) => this.mainCategoryList[k] === name)
        this.searchData.main_category = id || ''
      }
      this.getList(true)
    },
    onGroupChange(name) {
      if (name === '全部分组') {
        this.searchData.shop_groupids = ''
      } else {
        const g = this.groupList.find((x) => x.name === name)
        this.searchData.shop_groupids = g ? String(g.id) : ''
      }
      this.getList(true)
    },
    onBatchGroupChange(name) {
      if (name === '请选择分组') {
        this.batchGroupId = ''
      } else {
        const g = this.groupList.find((x) => x.name === name)
        this.batchGroupId = g ? String(g.id) : ''
      }
    },
    setGoodsStatus(val) {
      this.goodsStatus = val
      this.doSearch()
    },
    setOrderStatus(val) {
      this.orderStatus = val
    },
    toggleSelect(id) {
      const idx = this.selectedShopIds.indexOf(id)
      if (idx > -1) this.selectedShopIds.splice(idx, 1)
      else this.selectedShopIds.push(id)
    },
    selectAll() {
      this.selectedShopIds = this.filteredList.map((s) => s.shop_id)
    },
    unSelectAll() {
      const allIds = this.filteredList.map((s) => s.shop_id)
      this.selectedShopIds = allIds.filter((id) => !this.selectedShopIds.includes(id))
    },
    openAdd() {
      if (this.isWechat) {
        this.dialog = 'addWeixin'
        this.authCode = ''
        this.wechatShopInfo = { auth_code: '', shop_name: '', appid: '' }
      } else {
        this.dialog = 'addDouyin'
        this.selectedApp = null
      }
    },
    nextAddDouyin() {
      const app = this.apps.find((item) => item.id === this.selectedApp)
      if (!app || !app.authorizeUrl) {
        this.$message.warning('暂未获取到授权链接')
        return
      }
      this.dialog = null
      window.open(app.authorizeUrl, '_blank')
    },
    // 跳转微信购买/开通地址
    goWechatBuy(url) {
      if (url) {
        window.open(this.wechatBuyUrl, '_blank')
      } else {
        this.$message({message: '暂未配置微信购买地址', type: 'warning'})
      }
    },
    previewWechatShop() {
      const code = this.authCode.trim()
      if (!code || this.wechatChecking) return
      this.wechatChecking = true
      this.getWechatShopAuthCode({
        data: { code },
        success: (res) => {
          this.wechatChecking = false
          if (res.code === 200 && res.data && res.data.auth_code) {
            this.wechatShopInfo = {
              auth_code: res.data.auth_code,
              shop_name: res.data.shop_name || '微信小店',
              appid: res.data.appid || ''
            }
            this.dialog = 'confirmWeixin'
          } else {
            this.$message.error(res.msg || res.message || '获取授权信息失败')
          }
        }
      }).catch(() => {
        this.wechatChecking = false
        this.$message.error('获取授权信息失败，请稍后重试')
      })
    },
    confirmAddWechat() {
      if (!this.wechatShopInfo.auth_code || this.wechatAdding) return
      this.wechatAdding = true
      this.addWechatShop({
        data: { auth_code: this.wechatShopInfo.auth_code },
        success: (res) => {
          this.wechatAdding = false
          if (res.code === 200) {
            this.$message.success(res.msg || '添加成功')
            this.dialog = null
            this.authCode = ''
            this.wechatShopInfo = { auth_code: '', shop_name: '', appid: '' }
            this.getList(true)
          } else {
            this.$message.error(res.msg || res.message || '添加失败')
          }
        }
      }).catch(() => {
        this.wechatAdding = false
        this.$message.error('添加失败，请稍后重试')
      })
    },

    /**
     *  提交「星好货打单」授权码，对接 /api/v1/wxshop/shop/bind
     * 星好货打单授权码绑定微信小店
     * POST /api/v1/wxshop/shop/bind  body: { authCode }
     */
    submitWechatShop2() {
      const code = (this.authCode2 || '').trim()
      if (!code) {
        this.$message({message: '请输入授权码', type: 'warning'})
        return
      }
      if (this.wechatChecking2) return
      this.bindWxShopByAuthCode({
        data: { authCode: code,xhh_business_user_id: localStorage.getItem('business_user_id')},
        success: (res) => {
          this.wechatChecking2 = false
          if (res.code === 200) {
            this.$message({ message: res.msg || res.message || '绑定成功', type: 'success' })
            this.dialog = null
            this.authCode = ''
            this.wechatShopInfo = { auth_code: '', shop_name: '', appid: '' }
            this.getList(true)
          } else {
            this.$message({ message: res.msg || res.message || '绑定失败', type: 'error' })
          }
        },
        error: () => {
          this.wechatAdding = false
          this.$message({ message: '绑定失败，请稍后重试', type: 'error' })
        }
      })
    },



    /**
     * —— 关店 ——*/
    openClose(s) {
      this.closeShop = s
      this.closePwd = ''
    },
    confirmClose() {
      if (!this.closePwd) return
      if (this.closing) return
      this.$confirm('是否确认关店？店铺关闭后，之前有关店铺的所有操作均会丢失，无法找回。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.closing = true
        this.opCloseShop({
          data: { mer_shop_id: this.closeShop.shop_id, password: this.closePwd },
          success: (res) => {
            this.closing = false
            if (res.code === 200) {
              this.$message.success(res.msg)
              this.closeShop = null
              this.getList(true)
            } else {
              this.$message.error(res.msg)
            }
          }
        })
      }).catch(() => {})
    },

    /**
     * —— 配置搬家 —— */
    openMoveConfig(item) {
      const shopId = Number(item.shop_id || 0)
      if (!shopId) {
        this.$message.error('店铺信息异常，缺少本地店铺ID')
        return
      }
      if (this.isWechat) this.$refs.wxMoveConfigRef.show(shopId)
      else this.$refs.ddMoveConfigRef.show(shopId)
    },
    /**
     * —— 分组 ——*/
    checkGroupPermission() {
      if (this.$store.state.login.user_level == 9) {
        this.$message.error('普通会员无法使用分组')
        return false
      }
      return true
    },
    openBatchGroup() {
      if (!this.checkGroupPermission()) return
      this.batchGroupVisible = true
      this.batchGroupId = ''
    },
    confirmBatchGroup() {
      if (this.batchGroupId === '' || this.batchGroupId === null) {
        this.$message.warning('请选择分组');
        return;
      }
      if (this.batchGroupLoading) return
      this.batchGroupLoading = true
      this.opShopBoardBatchSetGroup({
        data: { mer_shop_ids: this.selectedShopIds, group_id:this.batchGroupId === 0?null: this.batchGroupId },
        success: (res) => {
          this.batchGroupLoading = false
          if (res.code === 200) {
            this.$message.success('设置成功')
            this.batchGroupVisible = false
            this.selectedShopIds = []
            this.loadGroups()
            this.getList(true)
          } else {
            this.$message.error(res.message || '设置失败')
          }
        }
      })
    },
    openGroupMgmt() {
      if (!this.checkGroupPermission()) return
      this.groupMgmtVisible = true
      this.loadGroups()
    },
    openGroupForm(g) {
      if (g) {
        this.groupForm = { id: g.id, name: g.name, sort: g.sort || 0 }
      } else {
        this.groupForm = { id: null, name: '', sort: 0 }
      }
      this.groupFormVisible = true
    },
    submitGroupForm() {
      if (!this.groupForm.name) {
        this.$message.warning('请输入分组名称')
        return
      }
      if (this.groupFormLoading) return
      this.groupFormLoading = true
      const data = { name: this.groupForm.name.trim(), sort: this.groupForm.sort || 0 }
      const done = (res, msg) => {
        this.groupFormLoading = false
        if (res.code === 200) {
          this.$message.success(msg)
          this.groupFormVisible = false
          this.loadGroups()
        } else {
          this.$message.error(res.message || res.msg || '保存失败')
        }
      }
      if (this.groupForm.id) {
        this.opShopBoardGroupUpdate({
          id: this.groupForm.id,
          data,
          success: (res) => done(res, '修改成功')
        })
      } else {
        this.opShopBoardGroupCreate({
          data,
          success: (res) => done(res, '新增成功')
        })
      }
    },
    delGroup(g) {
      this.$confirm(`确定要删除分组「${g.name}」吗？`, '提示', { type: 'warning' }).then(() => {
        this.opShopBoardGroupDelete({
          id: g.id,
          success: (res) => {
            if (res.code === 200) {
              this.$message.success('删除成功')
              this.loadGroups()
            } else {
              this.$message.error(res.message || '删除失败')
            }
          }
        })
      }).catch(() => {})
    },
    moveGroup(row,index,type) {
      if(index===0&&type==='asc') return
      if(index===this.groupList.length-1&&type==='desc') return
      let sort =0
      if(type==='asc') sort = this.groupList[index-1].sort-1
      if(type==='desc') sort = this.groupList[index+1].sort+1
      this.opShopBoardGroupUpdate({
        id: row.id,
        data:{ name: row.name.trim(), sort:sort<0?0:sort },
        success: (res) => {
          if(res.code===200){
            this.loadGroups()
          }
        }
      })
    },

    /**
     * —— 温馨提示 ——
     */
    loadAccountReminders(){
      this.getAccountReminders({
        success: (res) => {
          if (res.code !== 200 || !res.data) {
            return
          }
          this.showAccountReminders(res.data)
        }
      })
    },
    showAccountReminders(data){
      const groups = [
        { key: 'dd_order_app', label: '抖店订单应用' },
        { key: 'purchase_account', label: '采购账号' },
      ]
      const typeMap = [
        { field: 'expire_soon', text: '3天内到期' },
        { field: 'expired', text: '已过期' },
        { field: 'token_invalid', text: 'token失效' },
        { field: 'auth_closed', text: '授权已关闭', ddOnly: true },
      ]
      const sections = []
      let hasPurchase = false
      groups.forEach(group => {
        const block = data[group.key] || {}
        const items = []
        typeMap.forEach(typeItem => {
          if (typeItem.ddOnly && group.key !== 'dd_order_app') {
            return
          }
          const names = block[typeItem.field] || []
          if (!names.length) {
            return
          }
          items.push({ text: typeItem.text, names: [...names] })
        })
        if (items.length) {
          sections.push({ label: group.label, items })
          if (group.key === 'purchase_account') {
            hasPurchase = true
          }
        }
      })
      if (!sections.length) {
        return
      }
      this.accountReminderSections = sections
      this.hasPurchaseAccountReminder = hasPurchase
      this.accountReminders = true
    },
    goPurchaseManage(){
      this.accountReminders = false
      this.$router.push('/new_finance_workbench?menu=purchase')
    },

    /**
     * —— 不确定类目商品 ——*/
    getDdProductExistCategoryMisplaced(){//获取类目不正确的商品
      let param = {limit:1, page:1, state:13}
      this.getGoodsList({
        data: param, success: (res) => {
          if (res.code === 200) {
            if(res.data?.pagination?.total>0){
              this.$refs.isvDialogRef.show()
            }
          } else {
            this.$message({message: res.msg, type: 'error',});
          }
          this.isLoading = false
        }
      })
    },
  }
}
</script>

<style scoped>
.w220{
  width: 220px;
}
.custom-form-wrap :deep(.el-input--mini .el-input__inner) {
  height: 26px;
  line-height: 26px;
}
.gx-sw {
  min-height: 100vh;
  background: #F4F6F8;
  font-family: 'Noto Sans SC', sans-serif;
}

.gx-sw__sidebar {
  flex-shrink: 0;
  background: #EEF1F6;
  border-right: 1px solid #DDE2EC;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  scrollbar-width: none;
  position: relative;
  transition: width .25s cubic-bezier(.4, 0, .2, 1);
}
.gx-sw__sidebar::-webkit-scrollbar {
  display: none;
}
.gx-sw__collapse {
  position: absolute;
  top: 10px;
  right: -12px;
  z-index: 20;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid rgba(212, 169, 70, .3);
  background: #EEF1F6;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all .25s;
}
.gx-sw__collapse:hover {
  background: #1a2040;
  border-color: #D4A946;
}
.gx-sw__collapse span {
  font-size: 10px;
  color: #A0AEC0;
  display: inline-block;
  transition: transform .25s;
}
.gx-sw__nav {
  flex: 1;
  padding: 8px 0;
  overflow-y: auto;
  scrollbar-width: none;
}
.gx-sw__item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding: 9px 14px;
  border: none;
  border-left: 3px solid transparent;
  background: transparent;
  cursor: pointer;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 13px;
  color: #5C6B73;
  text-align: left;
  transition: all .18s ease;
}
.gx-sw__item:hover {
  background: rgba(255, 255, 255, .72);
  color: #1A1A2E;
}
.gx-sw__item--on {
  background: #FFFFFF;
  border-left-color: #fa5757;
  color: #1A1A2E;
  font-weight: 600;
}
.gx-sw__item-icon {
  font-size: 15px;
  flex-shrink: 0;
}
.gx-sw__item-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ── 店铺管理（严格对照新版 StoreManagementBase） ── */
.gx-shop__title {
  font-family: 'Noto Serif SC', serif;
  font-size: 24px;
  font-weight: 600;
  color: #1A1A2E;
  margin: 0 0 20px;
}
.gx-shop__filter {
  background: rgb(255, 255, 255);
  border-radius: 8px;
  border: 1px solid rgb(224, 224, 236);
  padding: 10px 14px;
  margin-bottom: 14px;
  box-shadow: rgba(0, 0, 0, 0.04) 0px 1px 4px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}


.gx-shop__search input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 12px;
  color: #1A1A2E;
  background: none;
}

.gx-shop__btn-add {
  height: 32px;
  padding: 0 16px;
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 13px;
  font-weight: 600;
  background: transparent;
  border: 1px solid rgb(212, 169, 70);
  color: rgb(212, 169, 70);
  opacity: 1;
  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: none;
  transform: none;
  margin-bottom: 16px;
}
.gx-shop__btn-add:hover {
  background: rgb(225, 229, 238);
  box-shadow: O O 10px rgba(212, 169, 70, 0.3);
  transform: scale(1.03) ;
}
.gx-shop__app-filter-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.gx-shop__app-filter-label {
  font-size: 12px;
  color: #6A6A8A;
  white-space: nowrap;
  min-width: 84px;
}
.gx-shop__app-filter-btns {
  display: flex;
  gap: 4px;
}
.gx-shop__app-filter-btn {
  height: 26px;
  padding: 0px 10px;
  border-radius: 4px;
  cursor: pointer;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  background: rgb(255, 255, 255);
  border: 1px solid rgb(224, 224, 236);
  color: rgb(102, 102, 102);
  transition: 0.14s;
}
.gx-shop__app-filter-btn--on {
  background: rgb(255, 245, 245);
  border: 1px solid rgb(200, 68, 60);
  color: rgb(200, 68, 60);
}

.gx-shop__bulk-btn {
  height: 26px;
  padding: 0px 10px;
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  font-weight: 400;
  background: rgb(255, 255, 255);
  border: 1px solid rgb(224, 224, 236);
  color: rgb(102, 102, 102);
  opacity: 1;
  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: none;
  transform: none;
}
.gx-shop__bulk-btn:hover {
  color: #1A1A2E;
  border-color: rgba(212, 169, 70, .35);
}
.gx-shop__bulk-btn:disabled {
  opacity: .5;
  cursor: not-allowed;
}

/* 卡片网格 */
.gx-shop__cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin-bottom: 20px;
}
/* 店铺卡片（扁平风格，对齐原型） */
.gx-shop__card {
  min-width: 320px;
  position: relative;
  border-radius: 10px;
  padding: 14px;
  background: #FFFFFF;
  border: 1px solid #E0E0EC;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .05);
  display: flex;
  flex-direction: column;
  transition: border .25s, box-shadow .25s, transform .25s;
}
.gx-shop__card:hover {
  border-color: rgba(200, 68, 60, .33);
  box-shadow: 0 6px 24px rgba(255, 77, 79, .09);
  transform: translateY(-2px);
}
.gx-shop__card--wx:hover {
  border-color: rgba(34, 197, 94, .33);
  box-shadow: 0 6px 24px rgba(34, 197, 94, .09);
}
.gx-shop__check {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: 1.5px solid #E0E0EC;
  background: #FFFFFF;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: all .15s;
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 1;
}
.gx-shop__check--on {
  background: #C8443C;
  border-color: #C8443C;
}
.gx-shop__card--wx .gx-shop__check--on {
  background: #22C55E;
  border-color: #22C55E;
}
.gx-shop__card-close {
  transition: all .15s;
  display: flex;
  gap: 5px;
}
.gx-shop__card-close .gx-shop__card-btn{
  height: 22px;
  padding: 0 8px;
  border-radius: 4px;
  cursor: pointer;
  background: #fff;
  border: 1px solid #E0E0EC;
  font-size: 11px;
  color: #4A4A6A;
}
.gx-shop__card-close .gx-shop__card-btn:hover {
  border-color: #C8443C;
  color: #C8443C;
  background: #FFF5F5;
}
.gx-shop__card-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  margin-top: 2px;
  padding-left: 22px;
  padding-right: 40px;
}
.gx-shop__card-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  flex-shrink: 0;
  background: #FFF5F5;
  border: 1px solid #FFCCC7;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Noto Serif SC', serif;
  font-size: 15px;
  font-weight: 700;
  color: #C8443C;
}
.gx-shop__card--wx .gx-shop__card-icon {
  background: rgba(34, 197, 94, .07);
  border-color: rgba(34, 197, 94, .3);
  color: #22C55E;
}
.gx-shop__card-info {
  flex: 1;
  min-width: 0;
}
.gx-shop__card-name {
  font-size: 13px;
  font-weight: 600;
  color: #1A1A2E;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.3;
  margin-bottom: 3px;
}
.gx-shop__card-plat {
  display: inline-block;
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 10px;
}
.gx-shop__card-plat--dy {
  background: rgba(255, 77, 79, .07);
  border: 1px solid #FFCCC7;
  color: #C8443C;
}
.gx-shop__card-plat--wx {
  background: rgba(34, 197, 94, .07);
  border: 1px solid rgba(34, 197, 94, .3);
  color: #22C55E;
}
.gx-shop__card-divider {
  height: 1px;
  background: #E0E0EC;
  margin-bottom: 10px;
}
.gx-shop__card-meta {
  margin-bottom: 6px;
}
.gx-shop__card-meta-row {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}
.gx-shop__card-meta-label {
  font-size: 12px;
  color: #666666;
  min-width: 72px;
  flex-shrink: 0;
}
.gx-shop__card-meta-val {
  font-size: 12px;
  color: #1A1A2E;
  font-weight: 500;
}
.gx-shop__app-block {
  background: #EEF1F6;
  border-radius: 7px;
  border: 1px solid #E0E0EC;
  padding: 9px 11px;
  margin-bottom: 8px;
}
.gx-shop__app-block-row {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}
.gx-shop__app-block-row:last-of-type {
  margin-bottom: 0;
}
.gx-shop__app-block-title {
  display: flex;
  align-items: center;
  gap: 6px;
}
.gx-shop__app-block-name {
  font-size: 12px;
  color: #666666;
}
.gx-shop__app-block-sub {
  font-size: 12px;
  font-weight: 500;
  color: #999999;
}
.gx-shop__app-block-sub--ok {
  color: #52C41A;
}
.gx-shop__app-block-btn {
  height: 20px;
  padding: 0 8px;
  border-radius: 4px;
  cursor: pointer;
  background: linear-gradient(135deg, #C8443C, #F07575);
  border: none;
  font-size: 11px;
  font-weight: 600;
  color: #fff;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  transition: opacity .15s;
  margin-left: auto;
}
.gx-shop__app-block-btn:hover {
  opacity: .85;
}
.gx-shop__card--wx .gx-shop__app-block-btn {
  background: linear-gradient(135deg, #22C55E, #4ade80);
}
.gx-shop__app-block-label {
  font-size: 11px;
  color: #666666;
  min-width: 58px;
  flex-shrink: 0;
}
.gx-shop__app-block-status {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
}
.gx-shop__app-block-status--ok {
  color: #52C41A;
}
.gx-shop__app-block-status--err {
  color: #C8443C;
}
.gx-shop__app-block-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}
.gx-shop__app-block-status--ok .gx-shop__app-block-dot {
  background: #52C41A;
  box-shadow: 0 0 4px rgba(82, 196, 26, .67);
}
.gx-shop__app-block-status--err .gx-shop__app-block-dot {
  background: #C8443C;
  box-shadow: 0 0 4px rgba(200, 68, 60, .67);
}
.gx-shop__app-block-expire {
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  color: #999999;
}
.gx-shop__app-block-reauth {
  display: inline-flex;
  margin-top: 2px;
  font-size: 11px;
  color: #1677FF;
  text-decoration: none;
}
.gx-shop__app-block-reauth:hover {
  text-decoration: underline;
}
.gx-shop__empty {
  padding: 64px 0;
  text-align: center;
  border-radius: 16px;
  background: #F7F8FA;
  border: 1px solid rgba(212, 169, 70, .1);
  color: #6A6A8A;
}
.gx-shop__count {
  text-align: center;
  font-size: 13px;
  color: #6A6A8A;
}

/* ── 弹窗（DialogShell 体系） ── */
.gx-shop__modal {
  position: fixed;
  inset: 0;
  z-index: 700;
  background: rgba(0, 0, 0, .48);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.gx-shop__modal-box {
  width: 100%;
  max-width: 480px;
  border-radius: 10px;
  background: #FFFFFF;
  border: 1px solid rgba(212, 169, 70, .28);
  box-shadow: 0 20px 56px rgba(15, 23, 42, .14), 0 0 40px rgba(212, 169, 70, .1);
  overflow: hidden;
}
.gx-shop__modal-box--sm {
  max-width: 420px;
}
.gx-shop__modal-box--lg {
  max-width: 520px;
}
.gx-shop__modal-box--apps {
  max-width: 440px;
}
.gx-shop__modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 18px;
  border-bottom: 1px solid rgb(224, 224, 236);
  background: rgb(245, 240, 232);
}
.gx-shop__modal-title {
  font-family: 'Noto Serif SC', serif;
  font-size: 16px;
  font-weight: 600;
  color: #1A1A2E;
  position: relative;
  padding-left: 11px;
}
.gx-shop__modal-title::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 3px;
  height: 15px;
  border-radius: 2px;
  background: rgb(200, 68, 60)
}
.gx-shop__modal-close {
  cursor: pointer;
  color: #666666;
  font-size: 11px;
  padding: 4px;
  width: 26px;
  height: 26px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgb(255, 255, 255);
  border: 1px solid rgb(224, 224, 236);
}
.gx-shop__modal-close:hover {
  background: rgb(255, 245, 245);
}
.gx-shop__modal-body {
  padding: 18px 18px 20px;
}
.gx-shop__modal-steps-title{
  font-size: 13px;
  font-weight: 600;
  color: rgb(26, 26, 46);
  margin-bottom: 14px;
}
.gx-shop__modal-steps {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}
.gx-shop__modal-step {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 13px;
  color: #4A4A6A;
  line-height: 1.6;
}
.gx-shop__modal-step-num {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgb(200, 68, 60), rgb(224, 88, 88));
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  font-weight: 700;
  color: #F4F6F8;
  flex-shrink: 0;
  margin-top: 1px;
}
.gx-shop__modal-jump {
  display: block;
  width: 100%;
  padding: 12px 0;
  border-radius: 8px;
  text-align: center;
  background: linear-gradient(135deg, rgb(200, 68, 60), rgb(224, 88, 88));
  color: #F4F6F8;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0px 4px 14px rgba(255, 77, 79, 0.3);
  text-decoration: none;
  margin-bottom: 8px;
  transition: filter .2s;
}
.gx-shop__modal-jump:hover {
  filter: brightness(1.05);
}
.gx-shop__modal-label {
  font-size: 11px;
  color: #6A6A8A;
  letter-spacing: .08em;
  text-transform: uppercase;
  margin-bottom: 8px;
}
.gx-shop__modal-label--strong{
  font-family: "Noto Sans SC", sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: var(--gx-black);
  margin-bottom: 8px;
}
.gx-shop__modal-code-row {
  display: flex;
  gap: 10px;
}
.gx-shop__modal-input {
  flex: 1;
  height: 38px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid rgb(224, 224, 236);
  font-size: 13px;
  color: #1A1A2E;
  outline: none;
  box-sizing: border-box;
  transition: border .15s;
}
.gx-shop__modal-input:focus {
  border-color: rgba(212, 169, 70, .65);
}
.gx-shop__modal-warn {
  font-size: 13px;
  color: #1A1A2E;
  line-height: 1.65;
  margin-bottom: 20px;
  display: flex;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 8px;
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 204, 199);
}
.gx-shop__modal-warn-name {
  color: #c8443c;
  font-weight: 600;
}
.gx-shop__modal-foot {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #E1E5EE;
}
.gx-shop__modal-foot.no-top-bor{
  margin-top: 0px;
  border-top: none;
}
.gx-shop__btn {
  height: 32px;
  padding: 0 16px;
  border-radius: 6px;
  cursor: pointer;
  background: #FFFFFF;
  border: 1px solid rgb(224, 224, 236);
  font-size: 13px;
  font-weight: 400;
  color: #666666;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  transition: all .16s;

}
.gx-shop__btn:hover {
  border-color: rgba(245,245,245);
}
.gx-shop__btn--add {
  background: linear-gradient(135deg, #D4A946, #E8C778);
  border: none;
  font-weight: 600;
  color: #F4F6F8;
}
.gx-shop__btn--add.red{
  height: 38px;
  background: linear-gradient(135deg, rgb(200, 68, 60), rgb(224, 88, 88));
}
.gx-shop__btn--add.red:disabled{
  background: rgb(240, 240, 240);
  color: #999999;
  border-color: #999999;
}
.gx-shop__btn--danger {
  background: rgba(248, 113, 113, .1);
  border: 1px solid rgba(248, 113, 113, .4);
  color: rgb(200, 68, 60);
}
.gx-shop__btn:disabled {
  opacity: .5;
  cursor: not-allowed;
}


/* 选择应用 */
.gx-shop__apps {
  display: flex;
  gap: 16px;
  margin-bottom: 4px;
}
.gx-shop__app-card {
  flex: 1;
  padding: 18px 14px;
  border-radius: 8px;
  cursor: pointer;
  text-align: center;
  background: rgb(245, 240, 232);
  border: 2px solid rgb(224, 224, 236);
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all .2s;

}
.gx-shop__app-card--on {
  background: rgb(255, 245, 245);
  border: 2px solid rgb(200, 68, 60);
}
.gx-shop__app-card-icon {
  font-size: 32px;
  margin-bottom: 8px;
}
.gx-shop__app-card-name {
  font-size: 14px;
  font-weight: 600;
  color: #1A1A2E;
  margin-bottom: 4px;
}
.gx-shop__app-card-sub {
  font-size: 11px;
  color: #4A4A6A;
  margin-bottom: 6px;
}
.gx-shop__app-card-desc {
  font-size: 11px;
  color: #999999;
  line-height: 1.5;
}
.gx-shop__app-card--on .gx-shop__app-card-name,
.gx-shop__app-card--on .gx-shop__app-card-sub{
  color: rgb(200, 68, 60);
}

/* 设置分组 */
.gx-shop__batch-count {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: 4px;
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 204, 199);
  margin-bottom: 16px;
  font-size: 12px;
  color: rgb(200, 68, 60);
}
.gx-shop__batch-count-dot{
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: rgb(200, 68, 60);
}

/* 分组管理 */
.gx-shop__gm-toolbar {
  margin-bottom: 12px;
}
.gx-shop__gm-table {
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #E1E5EE;
}
.gx-shop__gm-table table {
  width: 100%;
  border-collapse: collapse;
}
.gx-shop__gm-table th {
  padding: 9px 14px;
  text-align: left;
  background: #F5F0E8;
  font-size: 11px;
  font-weight: 500;
  color: #4A4A6A;
  border-bottom: 1px solid #E1E5EE;
  letter-spacing: .04em;
}
.gx-shop__gm-table td {
  padding: 10px 14px;
  font-size: 13px;
  color: #1A1A2E;
  border-top: 1px solid #f5f5f5;
}
.gx-shop__gm-name {
  font-weight: 500;
}
.gx-shop__gm-count {
  font-family: 'JetBrains Mono', monospace;
  color: #c8443c!important;
  font-weight: 600;
}
.gx-shop__gm-sort {
  display: flex;
  gap: 3px;
}
.gx-shop__gm-sort button {
  width: 22px;
  height: 22px;
  border-radius: 3px;
  border: 1px solid #E1E5EE;
  background: #FFFFFF;
  cursor: pointer;
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  color: #4A4A6A;
  transition: all .16s;
}
.gx-shop__gm-sort button:hover {
  border-color: #C8443C;
  color: #C8443C;
}
.gx-shop__gm-ops {
  display: flex;
  gap: 6px;
}
.gx-shop__gm-op {
  height: 24px;
  padding: 0 8px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 11px;
  border: 1px solid;
  transition: all .16s;
}
.gx-shop__gm-op--edit {
  background: #E6F4FF;
  border-color: #91CAFF;
  color: #1677FF;
}
.gx-shop__gm-op--edit:hover {
  background: rgb(22,119,255);
  color: #fff;
}
.gx-shop__gm-op--del {
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 204, 199);
  font-size: 11px;
  color: rgb(200, 68, 60);
}
.gx-shop__gm-op--del:hover {
  background: #c8443c;
  color: #fff;
}
.gx-shop__gm-name-input {
  position: relative;
}
.gx-shop__gm-name-count {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  color: #6A6A8A;
  pointer-events: none;
}
.gx-shop__gm-sort-input {
  display: flex;
  align-items: center;
  border: 1px solid #E1E5EE;
  border-radius: 4px;
  overflow: hidden;
  width: 120px;
}
.gx-shop__gm-sort-input button {
  width: 32px;
  height: 32px;
  border: none;
  background: #F5F0E8;
  cursor: pointer;
  font-size: 16px;
  color: #1A1A2E;
}
.gx-shop__gm-sort-input input {
  min-width: 0;
  flex: 1;
  height: 32px;
  border: none;
  outline: none;
  text-align: center;
  font-family: 'JetBrains Mono', monospace;
  font-size: 14px;
  color: #1A1A2E;
}
.gx-sw--category .gx-main > *:not(.wx-category) {
  display: none !important;
}
.gx-sw--category .gx-main {
  padding: 0;
}

/* —— 账号提醒弹窗 ——*/
.account_reminder_dialog{line-height: 1.6;color: #333;}
.account_reminder_tip{display: flex;align-items: flex-start;font-size: 14px;color: #666;margin-bottom: 16px;}
.account_reminder_tip .el-icon-warning{color: #e6a23c;font-size: 18px;margin-right: 8px;margin-top: 2px;flex-shrink: 0;}
.account_reminder_block{margin-bottom: 16px;padding: 12px 14px;background: #fff9f0;border-radius: 6px;border: 1px solid #ffe8cc;}
.account_reminder_block:last-child{margin-bottom: 0;}
.account_reminder_label{font-size: 14px;font-weight: bold;color: #333;margin-bottom: 8px;}
.account_reminder_item{font-size: 13px;color: #666;line-height: 22px;margin-top: 4px;}
.account_reminder_type{color: #f0413e;}
.account_reminder_names{color: #333;}
/* —— 账号提醒弹窗 ——*/

@media (max-width: 1200px) {
  .gx-shop__cards {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 900px) {
  .gx-shop__cards {
    grid-template-columns: 1fr;
  }
}
</style>
